module.exports = __webpack_public_path__ + "media/images/camera-pat-93b0ca330a717a73c5fdbd7e2500f2e2.svg";